import validateField from './validateField';

export default (form, e) => {
  const message = form.querySelector('[data-message]');
  let errorField = null;
  // catch this case when it didn't find any message element
  if (!message) {
    return;
  }

  form.querySelectorAll('[data-required]').forEach((field) => {
    const status = validateField(field);

    if (status.passes) {
      return;
    }

    if (errorField) {
      return;
    }

    if (e) {
      // this is a form submit
      e.preventDefault();
      field.focus();
    }

    errorField = field;

    if (field.type === 'checkbox') {
      message.textContent = 'Oops! Please check the checkbox if you want to proceed.';
    } else if (field.type === 'captcha') {
      message.textContent = 'Please verify you are human.';
    } else {
      message.textContent =
        'Oops! Some fields are missing information or are incorrect. Please update and then click submit.';
    }
  });

  if (errorField === null) {
    message.textContent = '';
    return true;
  }

  return false;
};
